import React, { useMemo } from "react";
import { FaChartPie } from "react-icons/fa";
import "./StatusOverview.css";

const StatusOverview = ({ stats }) => {
  const { upcoming, completed, cancelled, pending, total } = stats;

  const donutStyle = useMemo(() => {
    if (!total) {
      return { background: "conic-gradient(#e2e8f0 0deg 360deg)" };
    }
    const u = (upcoming / total) * 360;
    const c = (completed / total) * 360;
    const x = (cancelled / total) * 360;
    const p = (pending / total) * 360;
    return {
      background: `conic-gradient(
        #3b82f6 0deg ${u}deg,
        #22c55e ${u}deg ${u + c}deg,
        #ef4444 ${u + c}deg ${u + c + x}deg,
        #f97316 ${u + c + x}deg ${u + c + x + p}deg
      )`,
    };
  }, [upcoming, completed, cancelled, pending, total]);

  const legendItems = [
    { key: "upcoming", label: "Upcoming", value: upcoming, tone: "blue" },
    { key: "completed", label: "Completed", value: completed, tone: "green" },
    { key: "cancelled", label: "Cancelled", value: cancelled, tone: "red" },
    { key: "pending", label: "Pending", value: pending, tone: "orange" },
  ];

  return (
    <article className="status-overview">
      <div className="status-overview__accent" aria-hidden="true" />

      <div className="status-overview__head">
        <div className="status-overview__title-wrap">
          <span className="status-overview__icon-badge">
            <FaChartPie aria-hidden />
          </span>
          <div>
            <h3 className="status-overview__title">Status Overview</h3>
            <p className="status-overview__subtitle">Booking distribution at a glance</p>
          </div>
        </div>
      </div>

      <div className="status-overview__body">
        <div className="status-overview__chart-wrap">
          <div className="status-overview__donut" style={donutStyle}>
            <div className="status-overview__donut-hole">
              <strong>{total}</strong>
              <span>Total Bookings</span>
            </div>
          </div>
        </div>

        <ul className="status-overview__legend">
          {legendItems.map(({ key, label, value, tone }) => (
            <li key={key} className={`status-overview__legend-item status-overview__legend-item--${tone}`}>
              <span className="status-overview__legend-dot" />
              <span className="status-overview__legend-label">{label}</span>
              <span className="status-overview__legend-value">{value}</span>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
};

export default StatusOverview;
